import $ from 'jquery';

const EmbedMessage = (el) => {
    const $el = $(el);
    const $button = $el.find('.js-embed-button');

    $button.click((e) => {
        const content = $el.data('content');
        $el.html(content);
        console.log($el);
        $el.addClass('js-state-embed-visible');
    });
}

export default EmbedMessage;